import React from "react";

export default {
  'PrioritySettingRow.Wrapper.Input': ({ value }, _, internalStateSetter) => {
    if (value.length < 21) {
      internalStateSetter({ inputVal: value })
    }
  },
  'PrioritySettingRow.Button': async ({ isEditing, inputVal, inputRef }, outlet, internalStateSetter) => {
    if (isEditing) {
      outlet({ value: inputVal });
      internalStateSetter({ isEditing: !isEditing });
      return;
    }

    let newInputRef = inputRef;
    if (!newInputRef) {
      newInputRef = React.createRef(null);
      await internalStateSetter({ inputRef: newInputRef });
    }
    await internalStateSetter({ isEditing: !isEditing });
    newInputRef?.current?.children?.[0]?.focus();
  },
}